// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import InCorrectIcon from "../images/IncorrectNew.svg"
import CorrectIcon from "../images/CorrectIcon.svg"
import DropableLabel from "./DropableLabel";
import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialCost from "../images/Social-cost.svg"
import ExternalCost from "../images/External-cost.svg"
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";

import { Grid, Typography } from "@material-ui/core";

var _ = require('lodash');

var CanvasJSChart = CanvasJSReact.CanvasJSChart;
var CanvasJS = CanvasJSReact.CanvasJS;

const BubbleAndLine2 = (props) => {
  const [reRender, setReRender] =useState(0)
  const [answerCoordinates, setAnswerCoordinates] =useState([{style: {}, XYPoint: {}}])
  const [correctCount, setCorrectCount] =useState(0)
  const [allCorrect, setAllCorrect] =useState(true)
  const [xLabel, setXLabel] =useState("")
  const [yLabel, setYLabel] =useState("")
  const { qIndex, handleReloadClick, classes } = props;
  const [previousPoints, setPreviousPoints] = useState([{x: 50, y: 10, cursor: 'pointer', z: 3}, {x: 150, y: 20, cursor: 'pointer', z: 3}, {x: 250, y: 30, cursor: 'pointer', z: 3}])
  const my_w = Array.from({ length: questionsAnswers[qIndex].col }, (_, row) => {
    let dd = Array.from({ length: questionsAnswers[qIndex].row }, (_, col) => ({
      x: (row+1)*questionsAnswers[qIndex].step,
      y: (col+1)*questionsAnswers[qIndex].stepY,
      cursor: "pointer",
      z: 3
    }))
    return dd
  })

  const [chartData, setChartData] =useState([])
  const [bubbleData, setBubbleData] =useState([])
  const [bubbleColor, setBubbleColor] =useState('#8C479B')
  const [lineData, setLineData] =useState([])
  const [submit, setSubmit] =useState(false)
  const correctAnswers = questionsAnswers[qIndex].answer

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "scatter",
      color: 'transparent',
      markerSize: isMobile? 10 : 25,
      click: (event, elements) => {
        if(!submit){
          // x change: 45 = > 45/5 =>9 so 1 chart point on x is 9px
          // y change 24 => 24/5 => 4.7 so 1 chart point on y is 4.5px
          // base 0f x is 26
          // base 0f y is 66
          // margin form left = 30
          // margin form top = 10
          let obj = event.dataPoint
          let correct_or_not = isCorrectAnswer(obj)
          let tempdata = data
          let existingIndex = tempdata[2].dataPoints.findIndex((dataPoint) =>
            dataPoint.x === obj.x &&
            dataPoint.y === obj.y &&
            dataPoint.cursor === obj.cursor &&
            dataPoint.z === obj.z
          );

          if (existingIndex === -1) {
            // If the object is not found, push it to the array
            tempdata[2].dataPoints.push(obj);
          } else {
            // If the object is found, remove it from the array
            tempdata[2].dataPoints.splice(existingIndex, 1);
          }
          let tmpAns ={
            style: {
              // left: (event.dataPoint.x * 7.8) + 30 + 20,
              // top: ((60 - event.dataPoint.y) * 4.85) + 66 - 25,
              top: event.chart.axisY[0].convertValueToPixel(event.dataPoint.y) + 10,
              left: event.chart.axisX[0].convertValueToPixel(event.dataPoint.x),
              position: 'absolute',
              fontSize: 16,
              zIndex: 100,
              fontWeight: 700,
              color: correct_or_not ? '#008002' : '#fe0000'},
              XYPoint: {x: obj.x, y: obj.y}
          }
          setAnswerCoordinates(prevCoordinates => [
            ...prevCoordinates,
            tmpAns // New object to add
          ]);
          setChartData(tempdata)
          setReRender(Math.random())
        }
      },
      dataPoints: [].concat.apply([], my_w)
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 20,
      color: bubbleColor,
      dataPoints: bubbleData
    },
    {
      type: "spline",
      color: bubbleColor,
      lineThickness: isMobile? 3 : 5,
      dataPoints: lineData
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 20,
      color: '#003e4c',
      dataPoints: [{x: 50, y: 10, cursor: 'pointer', z: 3}, {x: 150, y: 20, cursor: 'pointer', z: 3}, {x: 250, y: 30, cursor: 'pointer', z: 3}]
    },
    {
      type: "spline",
      color: '#003e4c',
      lineThickness: isMobile? 3 : 5,
      dataPoints: [{x: 10, y: 6, cursor: 'pointer', z: 3}, {x: 50, y: 10, cursor: 'pointer', z: 3}, {x: 150, y: 20, cursor: 'pointer', z: 3}, {x: 250, y: 30, cursor: 'pointer', z: 3}, {x: 290, y: 34, cursor: 'pointer', z: 3}]
    },
  ]

  const isCorrectAnswer = (ans) => {
    let isCorrect = false
    correctAnswers.map((correctAnswer) => {
      if(correctAnswer.x === ans.x && correctAnswer.y === ans.y){
        isCorrect = true
      }
    })
    return isCorrect
  }

  const clearScreen = () => {
    console.log('clearScreen', answerCoordinates)
    setSubmit(false)
    setCorrectCount(0)
    setAllCorrect(true)
    setXLabel("")
    setYLabel("")
    setBubbleData([])
    setBubbleColor('#8C479B')
    setLineData([])
    data[2].dataPoints = []
    setChartData(data)
    setAnswerCoordinates([{style: {}, XYPoint: {}}])
}

  const isAllAnswerisCorrect = () => {
    if(correctAnswers.length !== chartData[2].dataPoints.length)
    {
      setAllCorrect(false)
      return false
    }
    let tempAllCorrect = true
    let temp = false
    let tempCount = 0
    correctAnswers.map((correctAnswer) => {
      temp = false
      chartData[2].dataPoints.map((point) => {
        if(correctAnswer.x === point.x && correctAnswer.y === point.y){
          temp = true
        }
      })
      tempAllCorrect = tempAllCorrect && temp
      if(temp){
        tempCount = tempCount + 1
        setCorrectCount(tempCount)
      }
    })
    setAllCorrect(tempAllCorrect)
    return tempAllCorrect
  }

  useEffect(() => {
    setChartData(data)
  }, [])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
      // padding: {
      //   top: 10,
      //   bottom: 0,
      // },
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
      // title: " asdas",
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile && 200,
    width: isMobile && 320 
  }

  useEffect(() => {
    if(submit === true){
      if(isAllAnswerisCorrect()){
        setLineData(bubbleData)
        data[2].dataPoints = chartData[2].dataPoints
        data[3].dataPoints = [{x: 10, y: 16, cursor: 'pointer', z: 3}].concat(chartData[2].dataPoints.concat([{x: 290, y: 44, cursor: 'pointer', z: 3}]))
        // data[2].color = "#008002"

      }else{
        data[2].dataPoints = chartData[2].dataPoints.map((point) => {
            if(isCorrectAnswer(point)){
              point.color = "#008002"
            }else{
              point.color = "#fe0000"
            }
          return point
        })
        // data[3].dataPoints = bubbleData
      }
      setChartData(data)
    }else{
      data[2].dataPoints = []
      setChartData(data)
    }
  },[submit])


  function getAnswertext() {
    let dots = answerCoordinates.length - 1
    console.log("dots", dots, allCorrect)
    if(dots === 0){
      return "You forgot to place the dots on the Supply Curve graph."
    }
    else if(dots < 3){
      return "You didn't place all the dots."
    }
    else if(dots >= 3 && !allCorrect){
      return "You placed the dots incorrectly."
    }
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  function submitButtonAction() {
    if(submit){
      if(allCorrect && (xLabel === "PRICE" && yLabel === "QUANTITY")){
        return allCorrect && (xLabel === "PRICE" && yLabel === "QUANTITY") ? "Next" : "Try Again"
      }else{
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  return (
      <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
           <div className={classes.leftInnerContainer}>
            <h3 className={classes.questionText}>{questionsAnswers[qIndex].question}</h3>
            <table className={classes.table}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th style={{ border: "1px solid white"}}><b>Quantity Supplied <br/> (tons of denim)</b></th>
                  <th style={{ border: "1px solid white", width: "50%" }}><b>Social Cost</b></th>
                </tr>
              </thead>
              <tbody style={{ border: "1px solid white" }}>
                {
                  correctAnswers.map((correctAnswer, index) => {
                    return(<tr key={index} className={classes.tableBody} style={{ backgroundColor: index%2 == 0 ? "#e1e1e1" : "#f0f0f0" }}>
                    <td style={{ border: "1px solid white" }}>{correctAnswer.x}</td>
                    <td style={{ border: "1px solid white" }}>${correctAnswer.y}</td>
                  </tr>)
                  })
                }
              </tbody>
            </table>

            {submit && 
            <div className={classes.answerTextContainer}>
            {allCorrect ?
              <Grid container className={classes.correctAnswerContainer}>
                <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon} />
                <Typography className={classes.answerText}>The social cost curve represents the private costs included in the supply curve AND the external costs of polluting the waterway.</Typography>
              </Grid>
            :
            <div className={classes.incorrectAnswerContainer}>
              <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon} />
            </div>
            }
            </div>
            }
           </div>
          </div>
        </div>
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`} >
          <DropableLabel
            right={isMobile ? '-24%' : "-20%"}
            marginTop={isMobile ? "12%" : "25%"}
            rotate={"rotate(270deg)"}
            label={"PRICE"}
          />
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>
          { submit && allCorrect &&
            <img src={SocialCost} alt="" className={classes.socialCostIcon} />
          }
          <img src={supplyIcon} alt="" className={classes.supplyIcon}/>
          <CanvasJSChart options = {options} />
          <DropableLabel
            right={isMobile ? "70%": "75%"}
            marginTop={"0%"}
            rotate={"rotate(0deg)"}
            label={"QUANTITY"}
          />
          {submit && allCorrect &&
            <img src={ExternalCost} alt="" className={classes.externalCostIcon} />
          }
          {submit && (getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
              {/* <p style={{ margin: "auto", color: "red", fontFamily: "Rubik", }}>Click "Try Again" button below</p> */}
            </div>
          }
          {/* <p style={{ position: "absolute", color: "#003e4c", right: 10, top: 358, fontFamily: "Rubik" }}>M</p> */}
          {/* {submit &&
          answerCoordinates.map((coord) => {
            if(Object.keys(coord.style).length > 0){
              return <div style={coord.style}>{"("+coord.XYPoint.x + ", " + coord.XYPoint.y+")"}</div>
            }
          })
          } */}
          <div className={classes.buttonContainer}>
            {
            getButtonText() !== 'Next' ? (<>
              <button className={classes.submitButtom} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.submitButtom} style={{color: "#00b1d9", marginLeft: 20, backgroundColor: '#fff' }} onClick={() => clearScreen()}>Clear</button>
              </>) : <button className={classes.submitButtomNext}  style={{ marginLeft: "10%" }} onClick={() => handleReloadClick()}>{getButtonText()}</button>
            }
          </div>
        </div>
      </div>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine2);